const styleFlags = {
  NONE: 0,
  HIDE_PANEL_HINTS_VIEW: 1,
  HIDE_PANEL_DETAILS: 2,
  HIDE_PANEL_HINT_TAP: 4,
  SHOW_FAVORITES_BUTTON_BADGE_ZERO: 8,
};

const defaultFlags = styleFlags.NONE;

export default class StyleFlags {
  declare _flags: number;

  constructor(flags?: number) {
    this._flags = flags === undefined ? defaultFlags : flags;
  }

  showPanelHintsView() {
    return this.hidePanelHintsView() === false;
  }

  hidePanelHintsView() {
    return (
      (this._flags & styleFlags.HIDE_PANEL_HINTS_VIEW) ===
      styleFlags.HIDE_PANEL_HINTS_VIEW
    );
  }

  showPanelDetails() {
    return this.hidePanelDetails() === false;
  }

  hidePanelDetails() {
    return (
      (this._flags & styleFlags.HIDE_PANEL_DETAILS) ===
      styleFlags.HIDE_PANEL_DETAILS
    );
  }

  showPanelHintTap() {
    return this.hidePanelHintTap() === false;
  }

  hidePanelHintTap() {
    return (
      (this._flags & styleFlags.HIDE_PANEL_HINT_TAP) ===
      styleFlags.HIDE_PANEL_HINT_TAP
    );
  }

  showFavoritesButtonBadgeZero() {
    return (
      (this._flags & styleFlags.SHOW_FAVORITES_BUTTON_BADGE_ZERO) ===
      styleFlags.SHOW_FAVORITES_BUTTON_BADGE_ZERO
    );
  }

  hideFavoritesButtonBadgeZero() {
    return this.showFavoritesButtonBadgeZero() === false;
  }
}

export { styleFlags };
